import type { Metric } from "web-vitals";

type ReportHandler = (metric: Metric) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
    if (typeof onPerfEntry === "function") {
        import("web-vitals").then((vitals) => {
            vitals.onCLS(onPerfEntry);
            vitals.onINP(onPerfEntry); // replaces FID
            vitals.onFCP(onPerfEntry);
            vitals.onLCP(onPerfEntry);
            vitals.onTTFB(onPerfEntry);
        });
    }
};

export default reportWebVitals;
